import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

//For ajax data
export const store = new Vuex.Store({
  state: {
    //env
    urls: {
      "homeEs" : {json: "http://projects.local/admin-multi-api/MultiresConnect.php"},
      "homeSp" : {json: "http://127.0.0.1:8070"}, 
      "prod" : {json: "https://admin-crm-multi.cogir.net/MultiresConnect.php"}
    },
    tenantId: "326c0bd4-11c9-41cc-be49-55e652fc8ea3", //cogir.net
    publicFolder: {prod: '/applications/', test: '/applications-test/'},
    parentsPage: [
      { value: "TaskAssignment", name: ""},
      { value: "UnitsList", name: ""},
      { value: "prospectslist", name: ""},
      { value: "UserList", name: ""},
      { value: "BuildingList", name: ""},
      { value: "UnitRented", name: ""},
      { value: "Budgets", name: ""},
      { value: "EditReference", name: ""},
      { value: "EditCreditCondition", name: ""},
      { value: "Reports", name: ""},
      { value: "DrApprobation", name: ""},
      { value: "ApplicationsList", name: ""},
      { value: "PastApplicationsList", name: ""},
      { value: "CreditReporting", name: ""},
      { value: "Leads", name: ""}

    ],
    excludesPage : ["Login","Submit", "ApplicationsList", "NotificationCenter", "NotificationCenterApplication"],
    accessRole: {
      "BuildingList": [3,4],
      "TaskAssignment": [4],
      "TaskDispatcher": [4,5,6],
      "TaskDispatcherRadio": [4],
      "PlannerGrouping": [4,5,6]
    },
    globalData: [],
    unitsInformation : [],
    prospectsInformation: [],

    //login
    msalObj: null,
    microsoftAccount: null,
    graphUser: null,
    user: null,
    userBuilding: null,
    userToken: null,

    //App.js
    buildings: [],
    labellist: [],
    typesList: [],
    subTypesList: [],
    provenancesList: [],
    applicationStatus: [],
    statusForProspect: [],
    reasonRemoved: [],

    //Unit
    ProspectFollowUp: [],
    ProspectUnits: [],
    unitsStatus: [], //liste des status des unités
    UnitStatusEvent: [],
    UnitsRented: [],
    budget: [],
    unitsSelected: [],
    tableStats: [],
    unitReload: false, //Flag pour reload value
    prospectForEdit: false,
    applicationColor: ["secondary", "secondary", "success", "danger", "primary", "success", "warning"],
    applicationReady: true,
    provenanceByMonth: [],

    //Prospect
    prospects: [],
    allUnitsRented: [],
    buildingForProspect: null,
    imeubleUnitForProspect: {IMMEUBLE: null, UNITE: null},
    visitList: [],
    reload: false,
    followupValue: false,
    prospectForUnit: {},
    unitsSelectedForProspect: [],
    applicantsType: [],
    applicantsDoc: [],
    search: "",
    prospectVisit: [],

    //addProspect
    from: "",
    fname: '',
    lname: '',
    email: '',
    tel: '',
    gender: null,
    communication: null,
    type: null,
    reference: null,
    description: '',

    //Admin
    taskSelect: null,
    applications: [],
    docType: [],
    creditStatus: [],
    creditCondition: [],
    creditNotification: [],
    userNotification: [],
    applicationFollowUp: [],
    buildingApplication: null,
    searchApplication: "",
    unitRentedVisit: [],
    userToEdit: null,
    buildingToEdit: null,
    userList: [],
    usersBuilding: [],
    reportData: [],
    graphColor: ['#0275d8', '#d9534f', '#5cb85c', '#f0ad4e', '#fd7e14', '#ffc107', '#5bc0de', "#6f42c1", "#96c11e"],
    creditRatingType: [],
    buildingFromQuery: null,
    treatmentData: null,
    statusLead: {Status: 1, IdLead: 0},
    buildingList: [],
    userListForTeam: [],
    groupMembersList: [],
    groupMemberTest: [],
  },
  getters: {
    //env
    getTaskSelected: state => {
      return state.taskSelect;
    },
    getUrlsList: state => {
      return state.urls;
    },
    getParentsPage: state => {
      return state.parentsPage;
    },
    getExcludesPage: state => {
      return state.excludesPage;
    },
    getPublicFolder: state => {
      return state.publicFolder;
    },
    getAccessRole: state => {
      return state.accessRole;
    },
    getTenantId: state => {
      return state.tenantId;
    },

    //login
    getmsalObj: state => {
      return state.msalObj;
    },
    getGraphUser: state => {
      return state.graphUser;
    },
    getUser: state => {
      return state.user;
    },
    getUserBuilding: state => {
      return state.userBuilding;
    },
    getMicrosoftAccount: state => {
      return state.microsoftAccount;
    },
    getUserToken: state => {
      return state.userToken;
    },

    //globalData
    getGlobalData: state => {
      return state.globalData;
    },
    getUnitsInformation: state => {
      return state.unitsInformation;
    },
    getProspectsInformation: state => {
      return state.prospectsInformation;
    },

    //App.js
    getLabelList: state => {
      return state.labellist;
    },
    getBuildingsList: state => {
      return state.buildings;
    },
    getTypesList: state => {
      return state.typesList;
    },
    getSubTypesList: state => {
      return state.subTypesList;
    },
    getProvenancesList: state => {
      return state.provenancesList;
    },
    getApplicationStatus: state => {
      return state.applicationStatus;
    },
    getStatusForProspect: state => {
      return state.statusForProspect;
    },
    getReasonRemoved: state => {
      return state.reasonRemoved;
    },

    //Unit
    getProspectFollowUp: state => {
      return state.ProspectFollowUp;
    },
    getProspectUnits: state => {
      return state.ProspectUnits;
    },
    getUnitsRented: state => {
      return state.UnitsRented
    },
    getUnitsStatus: state => {
      return state.unitsStatus;
    },
    getUnitStatusEvent: state => {
      return state.UnitStatusEvent;
    },
    getUnitsSelected: state => {
      return state.unitsSelected;
    },
    getProspectForEdit: state => {
      return state.prospectForEdit;
    },
    getUnitReload: state => {
      return state.unitReload;
    },
    getTableStats: state => {
      return state.tableStats;
    },
    getBudget: state => {
      return state.budget;
    },
    getApplicationColor: state => {
      return state.applicationColor;
    },
    getApplicationReady: state => {
      return state.applicationReady;
    },
    getProvenanceByMonth: state => {
      return state.provenanceByMonth;
    },

    //Prospect
    getProspectsList: state => {
      return state.prospects;
    },
    getAllUnitsRented: state => {
      return state.allUnitsRented;
    },
    getVisitList: state => {
      return state.visitList;
    },
    getbuildingForProspect: state => {
      return state.buildingForProspect;
    },
    getImmeubleUnitForProspect: state => {
      return state.imeubleUnitForProspect;
    },
    getReload: state => {
      return state.reload;
    },
    getFollowupValue: state => {
      return state.followupValue;
    },
    getProspectForUnit: state => {
      return state.prospectForUnit;
    },
    getUnitsSelectedForProspect: state => {
      return state.unitsSelectedForProspect;
    },
    getApplicantsType: state => {
      return state.applicantsType;
    },
    getSearch: state => {
      return state.search;
    },
    getProspectVisit: state => {
      return state.prospectVisit;
    },

    //addProspect
    getFrom: state => {
      return state.from;
    },
    getFname: state => {
      return state.fname;
    },
    getLname: state => {
      return state.lname;
    },
    getEmail: state => {
      return state.email;
    },
    getTel: state => {
      return state.tel;
    },
    getGender: state => {
      return state.gender;
    },
    getCommunication: state => {
      return state.communication;
    },
    getType: state => {
      return state.type;
    },
    getReference: state => {
      return state.reference;
    },
    getDescription: state => {
      return state.description;
    },

    //Admin
    
    getApplicationsList: state => {
      return state.applications;
    },
    getApplicationDocType: state => {
      return state.docType;
    },
    getApplicantsDoc: state => {
      return state.applicantsDoc;
    },
    getCreditStatus: state => {
      return state.creditStatus;
    },
    getCreditCondition: state => {
      return state.creditCondition;
    },
    getCreditNotification: state => {
      return state.creditNotification;
    },
    getUserNotification: state => {
      return state.userNotification;
    },
    getApplicationFollowUp: state => {
      return state.applicationFollowUp;
    },
    getBuildingApplication: state => {
      return state.buildingApplication;
    },
    getSearchApplication: state => {
      return state.searchApplication;
    },
    getUnitRentedVisit: state => {
      return state.unitRentedVisit;
    },
    getUserToEdit: state => {
      return state.userToEdit;
    },
    getBuildingToEdit: state => {
      return state.buildingToEdit;
    },
    getUserList: state => {
      return state.userList;
    },
    getUsersBuilding: state => {
      return state.usersBuilding;
    },
    getReportData: state => {
      return state.reportData;
    },
    getGraphColor: state => {
      return state.graphColor;
    },
    getCreditRatingType: state => {
      return state.creditRatingType;
    },
    getBuildingFromQuery: state => {
      return state.buildingFromQuery
    },
    getDataForTreatment: state => {
      return state.treatmentData;
    },
    getStatusLead: state => {
      return state.statusLead;
    },
    getBuildingListForUser: state => {
      return state.buildingList;
    },
    getUserListForTeam: state => {
      return state.userListForTeam;
    },
    getGroupMembersList: state => {
      return state.groupMembersList;
    },
    getGroupMemberTest: state => {
      return state.groupMemberTest;
    }
  },
  mutations: {
    //Login
    addGraphUser(state, graphUser) {
      state.graphUser = graphUser;
    },
    addmsalObj (state, msalObj) {
      state.msalObj = msalObj;
    },
    addUserToken(state, token) {
      state.userToken = token;
    },
    addMicrosoftAccount(state, microsoftAccount) {
      state.microsoftAccount = microsoftAccount;
    },
    addUser (state, user) {
      state.user = user;
    },
    addUserBuilding(state, obj) {
      state.userBuilding = obj;
    },

    //globalData
    addGlobalData(state, obj) {
      state.globalData = obj;
    },
    //globalData
    addUnitsInformation(state, obj) {
      state.unitsInformation = obj;
    },
    //globalData
    addProspectsInformation(state, obj) {
      state.prospectsInformation = obj;
    },

    //App.js
    addBuildingsList(state, obj) {
      state.buildings = obj;
    },
    addLabelList(state, obj) {
      state.labellist = obj;
    },
    addTypesList(state, obj) {
      state.typesList = obj;
    },
    addSubTypesList(state, obj) {
      state.subTypesList = obj;
    },
    addProvenancesList(state, obj) {
      state.provenancesList = obj;
    },
    addApplicationStatus(state, obj) {
      state.applicationStatus = obj;
    },
    addStatusForProspect(state, obj) {
      state.statusForProspect = obj;
    },
    addReasonRemoved(state, obj) {
      state.reasonRemoved = obj;
    },

    //Unit
    addProspectFollowUp (state, obj) {
      state.ProspectFollowUp = obj;
    },
    addProspectUnits (state, obj) {
      state.ProspectUnits = obj;
    },
    addUnitsStatus (state, obj) {
      state.unitsStatus = obj;
    },
    addUnitStatusEvent (state, obj) {
      state.UnitStatusEvent = obj;
    },
    addUnitsRented (state, obj) {
      state.UnitsRented = obj;
    },
    addBudget(state, obj) {
      state.budget = obj;
    },
    addUnitsSelected(state, obj) {
      state.unitsSelected = obj;
    },
    addTableStats(state, obj) {
      state.tableStats = obj;
    },
    setProspectForEdit(state, val) {
      state.prospectForEdit = val;
    },
    setUnitReload(state, val) {
      state.unitReload = val;
    },
    setApplicationReady(state, val) {
      state.applicationReady = val;
    },
    addProvenanceByMonth(state, val) {
      state.provenanceByMonth = val;
    },

    //Prospect
    addVisitList(state, obj) {
      state.visitList = obj;
    },
    addProspectsList (state, obj) {
      state.prospects = obj;
    },
    addAllUnitsRented(state, obj) {
      state.allUnitsRented = obj;
    },
    addBuildingForProspect(state, obj) {
      state.buildingForProspect = obj;
    },
    addImeubleUnitForProspect(state, obj) {
      state.imeubleUnitForProspect = obj;
    },
    setReloadValue(state, val) {
      state.reload = val;
    },
    setFollowupValue(state, val) {
      state.followupValue = val;
    },
    setprospectForUnit(state, val) {
      state.prospectForUnit = val;
    },
    addUnitsSelectedForProspect(state, obj) {
      state.unitsSelectedForProspect = obj;
    },
    addApplicantsType(state, obj) {
      state.applicantsType = obj;
    },
    setSearch(state, obj) {
      state.search = obj;
    },
    addProspectVisit(state, obj) {
      state.prospectVisit = obj;
    },

    //addProspect
    setFrom(state, val) {
      state.from = val;
    },
    setFname(state, val) {
      state.fname = val;
    },
    setLname(state, val) {
      state.lname = val;
    },
    setEmail(state, val) {
      state.email = val;
    },
    setTel(state, val) {
      state.tel = val;
    },
    setGender(state, val) {
      state.gender = val;
    },
    setCommunication(state, val) {
      state.communication = val;
    },
    setType(state, val) {
      state.type = val;
    },
    setReference(state, val) {
      state.reference = val;
    },
    setDescription(state, val) {
      state.description = val;
    },

    //Admin
    addTaskSelected(state, val) {
      state.taskSelect = val;
    },
    addApplicationsList(state, val) {
      state.applications = val;
    },
    addApplicationDocType(state, val) {
      state.docType = val;
    },
    addApplicantsDoc(state, val) {
      state.applicantsDoc = val;
    },
    addCreditStatus(state, val) {
      state.creditStatus = val;
    },
    addCreditCondition(state, val) {
      state.creditCondition = val;
    },
    addCreditNotification(state, val) {
      state.creditNotification = val;
    },
    addUserNotification(state, val) {
      state.userNotification = val;
    },
    addApplicationFollowUp(state, val) {
      state.applicationFollowUp = val;
    },
    addBuildingApplication(state, val) {
      state.buildingApplication = val;
    },
    setSearchApplication(state, val) {
      state.searchApplication = val;
    },
    addUnitRentedVisit(state, val) {
      state.unitRentedVisit = val;
    },
    addUserToEdit(state, val) {
      state.userToEdit = val;
    },
    addBuildingToEdit(state, val) {
      state.buildingToEdit = val;
    },
    addUserList(state, val) {
      state.userList = val;
    },
    addUsersBuilding(state, val) {
      state.usersBuilding = val;
    },
    addReportData(state, val) {
      state.reportData = val;
    },
    addCreditRatingType(state, val) {
      state.creditRatingType = val;
    },
    addBuildingFromQuery(state, val) {
      state.buildingFromQuery = val;
    },
    setDataForTreatment(state, val) {
      state.treatmentData = val;
    },
    setStatusLead(state, val) {
      state.statusLead = val;
    },
    addBuildingListForUser(state, val) {
      state.buildingList = val;
    },
    addUserListForTeam(state, val) {
      state.userListForTeam = val;
    },
    addGroupMembersList(state, val) {
      state.groupMembersList.push(val);
    },
    removeGroupMembersList(state, val) {
      state.groupMembersList = val;
    },
    addGroupMemberTest(state, val) {
      state.groupMemberTest.push(val);
    },
    removeGroupMembersListTest(state, val) {
      state.groupMemberTest = val;
    },
    
  }
})
